module.exports = __webpack_public_path__ + "static/media/POD.2efd2bc3.ico";